import React from "react"
import * as api from "brandguard/api"
import GenerateCorrectionShared from "brandguard/components/generate.correction"

interface props {
	item: api.VideoSearchResponseItem
	onCorrectionComplete?: (correctedEventId: string) => void
}

export default function GenerateCorrection(props: props): JSX.Element {
	return <GenerateCorrectionShared item={props.item} corrections={api.videos.corrections} progressLabel="video" onCorrectionComplete={props.onCorrectionComplete} />
}
